<!--
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
-->
<template>
  <component
    :is="icon"
    class="svg-icon"
    :icon-name="icon"
  />
</template>

<script>
import icons from '@/icons/icons';
export default {
  name: 'SvgIcon',
  extends: icons
};
</script>
